import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'MTM',
  version: 2,
  label: 'Momentum',
  pane: 'sub',
  category: 'momentum',
  series: 'price',
  order: 100,
  inputs: [period('timeperiod', 10, 'Length', 1)],
  outputs: [line('mom', 'MOM', COLOR.blue)],
  talib: { functions: ['MOM'], expr: 'MOM(close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod,
}
export default def
